// Some colors taken from our design guidelines:
// https://docs.google.com/document/d/19BOOS-XQ7XNVgT6jXb4s_adm_891Zbl9NVtAjcSddQw

export const Color = {
  // [DOC] 52, 46, 39, etc. are the values of the colors in CMYK encoding
  // See: https://www.w3schools.com/colors/colors_cmyk.asp
  grey87: "#212121",
  grey80: "#333333",
  grey76: "#3C3C3C",
  grey52: "#7B7B7B",
  grey46: "#898989",
  grey39: "#9C9C9C",
  grey15: "#D8D8D8",
  grey01: "#FCFCFC",

  green100: "#00FF00",

  blue: "#45BCFF",
  orange: "#FF9E45",

  hbYellow: "#f4e83e",
};
